import { KeyValueDefault } from "@/main/models/common";
import { CountryTypes, CountryActionTypes } from "./countryTypes";
import { CountryPublicResponse } from "@/main/models/response";

export function getCountriesUser(idUser: string | null = null): CountryActionTypes {
	return {
		type: CountryTypes.GET_COUNTRIES_USER,
		payload: {
			idUser,
		},
	};
}

export function getCountriesPublic(): CountryActionTypes {
	return {
		type: CountryTypes.GET_COUNTRIES_PUBLIC,
	};
}

export function saveCountriesUser(
	data: KeyValueDefault[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CountryActionTypes {
	return {
		type: CountryTypes.SAVE_COUNTRIES_USER,
		payload: { data, isError, errorMessages },
	};
}

export function saveCountriesPublic(
	data: CountryPublicResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CountryActionTypes {
	return {
		type: CountryTypes.SAVE_COUNTRIES_PUBLIC,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerCountriesUser(): CountryActionTypes {
	return {
		type: CountryTypes.RESET_REDUCER_COUNTRIES_USER,
	};
}
